import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const UserFirstName = (props) => {
  const { userFirstName, validationMessage } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("first_name")}
          validationMessage={
            validationMessage
              ? validationMessage
              : props.errors?.userFirstName?.message
          }
          id="userFirstName"
          placeholder={t("enter_first_name")}
          maxLength="30"
          name="userFirstName"
          inputDefaultValue={userFirstName}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("userFirstName", {
            required: `${t("validation_message.first_name_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default UserFirstName;
